import { z } from 'zod/v4'

export const AppConfigSchema = z.object({
  mainApiUrl: z.string().url(),
  sectionsApiUrl: z.string().url(),
  langschoolApiUrl: z.string().url(),
  keycloakUrl: z.string().url(),
  keycloakRealm: z.string(),
  keycloakClient: z.string(),
})

export type AppConfig = z.infer<typeof AppConfigSchema>

let APP_CONFIG: AppConfig | undefined

export async function pullAppConfig(): Promise<{
  appConfig?: AppConfig
  errors?: z.ZodIssue[]
}> {
  const isDev = import.meta.env.DEV
  const configPath = isDev ? '/config.local.json' : '/config.json'

  try {
    const resp = await fetch(configPath)
    if (!resp.ok) {
      throw new Error(`Failed to fetch config: ${resp.status}`)
    }
    const raw = await resp.json()
    const result = AppConfigSchema.safeParse(raw)
    if (result.success) {
      APP_CONFIG = result.data
      return { appConfig: APP_CONFIG }
    }
    return { errors: result.error.issues }
  } catch (e) {
    return { errors: [{ message: String(e) }] as z.ZodIssue[] }
  }
}

export function getAppConfig(): AppConfig {
  if (!APP_CONFIG) {
    throw new Error('App config not loaded. Call pullAppConfig() first.')
  }
  return APP_CONFIG
}
